import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import API from '../Utils/api'
import DetalhamentoPedido from "../_Components/DetalhamentoPedido";
import moment from 'moment';
import SubMasterTemplate from './SubMasterTemplate'
import { Link } from 'react-router-dom';
import Cleave from "cleave.js/react"


export class BilhetesMonitor extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      pedidos: [],
      user: JSON.parse(localStorage.getItem("user")),
      clienteSelecionado: null,
      pedidoSelecionado: null,
      cartelas: [],
      clientes: [],
      searchedPedidos: [],
      detalahamento: false,
      historicos: [],
      historicoSelecionado: undefined
    };
    this.listarPedidos();
    this.getHistoricos();
    this.selecionarPedido = this.selecionarPedido.bind(this)
    this.deselecionarPedido = this.deselecionarPedido.bind(this)
    this.getPedidoPorTransacao = this.getPedidoPorTransacao.bind(this)
    this.receberTodosPedidos = this.receberTodosPedidos.bind(this)

  }


  async getHistoricos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      })
      const response = await axiosInstance.get("historicos/")

      this.setState({ historicos: response.data.sort(this.compararDatas) })

    } catch (err) {
      console.log(err)
    }
  }

  compararDatas(a, b) {
    var A = new Date(a.dataInicial)
    var B = new Date(b.dataInicial)
    if (A < B) {
      return 1;
    }
    if (A > B) {
      return -1;
    }

    return 0
  }


  async deletarPedidoVazio() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/deletar-vazios", {
      });
    } catch (err) {
      console.log(err);
    }
  }

  deselecionarPedido(event) {
    this.setState({ pedidoSelecionado: null, clienteSelecionado: null })
    this.setState({ detalahamento: false })
    this.forceUpdate()

  }

  selecionarPedido(event) {
    const pedido = JSON.parse(event.target.accessKey)
    this.setState({ pedidoSelecionado: event.target.accessKey, clienteSelecionado: JSON.stringify(pedido.clienteId) })
    this.setState({ detalahamento: true })
    this.forceUpdate()
  }


  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };

  listarPedidos = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/listar-pedidos", {
        id: this.state.user._id
      });
      this.setState({ pedidos: response.data.reverse(), searchedPedidos: response.data });
      this.contarCartelas()
    } catch (err) {
      console.log(err);
    }
  };

  async buscarPedidosIntervalo(historicoSelecionado) {
    if (historicoSelecionado) {
      this.setState({ isLoad: true })
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        })
        const response = await axiosInstance.post("pedidos/intervalo-monitor",
          {
            dataInicial: historicoSelecionado.dataInicial,
            dataFinal: historicoSelecionado.dataFinal,
            monitorId: this.state.user._id
          })

        this.setState({ pedidos: response.data.reverse(), searchedPedidos: response.data })
        if (response.data) {
          this.setState({ isLoad: false })
          this.contarCartelas()
        }
      } catch (err) {
        console.log(err)
      }
    }
    else {
      this.listarPedidos()
    }
  }

  receberTodosPedidos() {

    var index = 0;
    var pedidos = this.state.pedidos.filter(pedido => pedido.recebido == false);

    var user = this.state.user
    var intervalo = setInterval(async function () {
      if (index >= pedidos.length) {
        clearInterval(intervalo);
      }

      var pedido = pedidos[index]

      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const transacao = await axiosInstance.post(
          'transacoes/criar-transacao',
          {
            data: new Date(),
            documento: pedido.codigo,
            valor: pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor),
            emissorId: pedido.clienteId._id,
            receptorId: pedido.cambistaId._id,
            tipo: 'Venda',
            observacao: 'VENDA CAMBISTA',
            status: true,
            natureza: 'ENTRADA',
            isEfetivada: false,
            taxaComissao: ((pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor)) / 100) * pedido.cambistaId.comissao
          }


        )
        if (transacao.data) {
          var receberP = await axiosInstance.post('pedidos/receber-pedido', {
            codigo: pedido.codigo,
            cambistaId: pedido.cambistaId._id,
            gerenteId: user._id,
            transacaoId: transacao.data._id
          })

        }
      } catch (err) {
        console.log(err);
      }
      index++;
    }, 200);

  }

  async getPedidoPorTransacao(e) {
    try {
      const response = await API.post("/api/pedidos/por-transacao", {
        transacaoId: e._id
      });
      return response.data
    } catch (err) {
      console.log(err);
    }
  };

  contarCartelas() {
    var cartelas = []
    this.state.pedidos.forEach(pedido => {
      pedido.cartelas.forEach(cartela => {
        cartelas.push(cartela)
      })
    })
    this.setState({ cartelas: cartelas })
  }

  async getClientesPorCambista(item) {
    this.setState({ pedidoSelecionado: item })
    try {
      const response = await API.post("/api/usuarios/listar-por-tutor", {
        tutorId: item.cambistaId._id
      });
      this.setState({ clientes: response.data.sort(this.compararNome) });
    } catch (err) {
      console.log(err);
    }
  };

  compararNome(a, b) {
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
      return 1;
    }
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
      return -1;
    }

    return 0
  }

  setCliente(e) {
    this.state.clienteSelecionado = JSON.parse(e.target.value);
    this.setState({ clienteSelecionado: JSON.parse(e.target.value) })
  }

  async salvarPedidoEditado() {
    this.state.pedidoSelecionado.clienteId = this.state.clienteSelecionado._id;
    this.state.pedidoSelecionado.cambistaId = this.state.clienteSelecionado.tutorId;
    if (this.state.clienteSelecionado) {
      try {
        const response = await API.post("/api/pedidos/modifica-pedido", {
          id: this.state.pedidoSelecionado._id,
          pedido: this.state.pedidoSelecionado
        });
        alert("Salvo com sucesso!")
        window.location.reload()
      } catch (err) {
        console.log(err);
      }
    }
  }

  searchCode(e) {
    var filter = [];
    this.state.pedidos.map(pedido => {

      pedido.cartelas.map(cartela => {
        if (cartela != undefined && cartela.codigo.includes(e.target.value)) {
          filter.push(pedido);
        }
      }
      )

    })


    { e.target.value != '' ? this.setState({ searchedPedidos: filter }) : this.setState({ searchedPedidos: this.state.pedidos }) }
  }


  selecionaIntervalo(e) {
    if (e.target.value !== 'NULL') {
      this.setState({ historicoSelecionado: JSON.parse(e.target.value).historico })
      this.buscarPedidosIntervalo(JSON.parse(e.target.value).historico);
    }
    else {
      this.setState({ historicoSelecionado: undefined })
      this.listarPedidos()
    }
  }

  render() {
    return (


      <SubMasterTemplate label="Cartelas">


        <div class="modal fade" id="exampleModalCenter2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50vw' }} role="document">
            <div class="modal-content "  >
              <div class="modal-header">
                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Editar o cliente do pedido</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <h4>Procure o cliente correto</h4>
                <select onChange={this.setCliente.bind(this)} style={{ zIndex: '3000' }} class="ml-1 custom-select">
                  <option value={JSON.stringify(null)} selected>Selecione um cliente</option>
                  {this.state.clientes.length > 0 ? this.state.clientes.map(cliente => {
                    return <option value={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</option>
                  }) : ""}
                </select>
              </div>
              <div class="modal-footer" style={{ justifyContent: 'flex-end' }}>
                <button className="btn btn-fill btn-success" onClick={this.salvarPedidoEditado.bind(this)}>Salvar</button>
              </div>
            </div>
          </div>
        </div>




        <div onClick={this.deselecionarPedido} class="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '95vw', marginTop: '-8em' }} role="document">
            <div class="modal-content "  >
              <div class="modal-header">
                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento pedido</h4>
                <button onClick={this.deselecionarPedido} type="button" class="close" data-dismiss="modal" aria-label="Close" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                {this.state.detalahamento && this.state.pedidoSelecionado ? <DetalhamentoPedido user={this.state.clienteSelecionado} pedido={this.state.pedidoSelecionado} /> : ""}
              </div>
              <div class="modal-footer" style={{ justifyContent: 'flex-end' }}>

              </div>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card strpied-tabled-with-hover">
                  <div class="card-header ">
                    <h4 class="card-title">
                      Acompanhe pedidos em tempo real
                    </h4>
                    <p class="card-category">Informações de pedidos.</p>
                    <p className="card-category">Numero de cartelas : {this.state.cartelas.length}</p>

                  </div>
                  <div class="card-body table-full-width table-responsive">
                    <div style={{ paddingLeft: "15em", display: 'flex' }}>
                      <Cleave
                        style={{ maxWidth: "20em" }}
                        data-length="7"
                        className={`ml-1 form-control`}
                        options={{
                          numericOnly: true,
                          delimiters: ['-'],
                          blocks: [5, 1]
                        }}

                        onChange={this.searchCode.bind(this)}
                        placeholder="código da cartela 00000-0"

                      />

                      <select onChange={this.selecionaIntervalo.bind(this)} className="custom-select ml-1">
                        <option value={'NULL'} selected >Cartelas atuais</option>
                        {this.state.historicos.map(historico => {
                          return <option value={JSON.stringify({ historico })}>{this.formatDate(historico.dataInicial)} ➨ {this.formatDate(historico.dataFinal)} </option>
                        })}
                      </select>
                    </div>
                    <table class="table table-hover table-striped">
                      <thead>
                        <tr>
                          <th>Data</th>
                          <th>Codigo</th>
                          <th>Cliente</th>
                          <th>Qtd de cartelas</th>
                          <th>Valor total</th>
                          <th className={this.state.historicoSelecionado ? 'd-none' : 'd-none'}>Editar</th>
                        </tr>
                      </thead>
                      <tbody>

                        {this.state.searchedPedidos.length > 0
                          ? this.state.searchedPedidos.map(
                            (item, index) => {
                              return (
                                <tr

                                >
                                  <td accessKey={JSON.stringify(item)}>{this.formatDate(item.data)}</td>
                                  <td style={{ cursor: 'pointer' }}
                                    accessKey={JSON.stringify(item)}
                                    data-toggle="modal" data-target="#exampleModalCenter"
                                    onClick={this.selecionarPedido} accessKey={JSON.stringify(item)}>{item.codigo}</td>
                                  <td accessKey={JSON.stringify(item)}>{item.clienteId ? item.clienteId.nome : "Desconhecido"}</td>
                                  <td accessKey={JSON.stringify(item)} class="pl-5">{item.cartelas ? item.cartelas.length : "0"}</td>
                                  <td accessKey={JSON.stringify(item)} class="pl-5">{item.cartelas ? (item.cartelas[0] ? (item.cartelas.length * item.cartelas[0].valor).toFixed(2) : "0") : "0"}</td>
                                  <td className={this.state.historicoSelecionado ? 'd-none' : 'd-none'}><button className="btn" data-toggle="modal" data-target="#exampleModalCenter2" onClick={() => this.getClientesPorCambista(item)} >Editar</button></td>
                                </tr>
                              );
                            }
                          )
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SubMasterTemplate>
    );
  }
}

export default BilhetesMonitor;
